var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-btn",on:{"click":_vm.transitionHome}}),_c('h1',[_vm._v("Rese")])])}
var staticRenderFns = []

export { render, staticRenderFns }